<script setup lang="ts">
  import { useSlots } from 'vue';

  import Icon from '../Icon/Icon.vue';

  const slots = useSlots();

  const hasSlots = !!slots.min && !!slots.max;

  if (!hasSlots) {
    throw new Error('RangeInput: please provide slots for min and max values.');
  }
</script>

<template>
  <div data-test="stash-range-input" class="stash-range-input flex gap-3">
    <!-- @slot field for minimal value input -->
    <slot name="min"></slot>

    <Icon name="transfer" class="mb-2 mt-auto" />
    <!-- @slot Field for maximal value input -->
    <slot name="max"></slot>
  </div>
</template>
